module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-c8476301.png";